import * as React from 'react';
export const AccordionItemContext = React.createContext(undefined);
const accordionItemContextDefaultValue = {
    onHeaderClick () {
    /** */ },
    open: false,
    disabled: false
};
export const AccordionItemProvider = AccordionItemContext.Provider;
var _React_useContext;
export const useAccordionItemContext_unstable = ()=>(_React_useContext = React.useContext(AccordionItemContext)) !== null && _React_useContext !== void 0 ? _React_useContext : accordionItemContextDefaultValue;
